<template>
  <div id="filter-app" :style="{ height: resolvedHeight }">
    <v-app>
      <v-main>
        <v-dialog
          v-model="isSidebarOpen"
          v-on:update:model-value="toggleSidebar"
          fullscreen
          :scrim="false"
          transition="dialog-bottom-transition"
          v-if="filterDesktopHide"
        >
          <template v-slot:activator="{ props }">
            <div id="filter-drawer-container">
              <v-btn
                variant="plain"
                v-bind="props"
                id="filter-drawer-button"
                width="248px"
                height="49px"
              >
                <img
                  src="../../../assets/icons/filter-icon.svg" fetchpriority="high" alt="Ícone de filtro"
                />&nbsp;Filtros
              </v-btn>
            </div>
          </template>
          <v-card id="filter-app-dialog">
            <v-toolbar dark color="#FF7A00" align-items="center">
              <v-toolbar-title class="title" align-items="center"
                >Filtros</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="closeSidebar">
                  <v-icon color="#FFFFFF">mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <FilterSidebar :closeSidebar="closeSidebar" :currentResolvedPadding="currentResolvedPadding" :validParam="validParam" />
          </v-card>
        </v-dialog>

        <div class="filter-app-content" v-else>
          <FilterSidebar :closeSidebar="closeSidebar" :currentResolvedPadding="currentResolvedPadding" :validParam="validParam"/>
        </div>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import PlatformsMixins from "@/mixins/PlatformsMixins";
import FilterSidebar from "@/components/FilterSidebar.vue";

export default {
  name: "FilterApp",
  mixins: [PlatformsMixins],
  components: {
    FilterSidebar,
  },
  data: function () {
    return {
      isSidebarOpen: false,
      currentResolvedHeight: '100vh',
      currentResolvedPadding: ''
    };
  },
  methods: {
    ...mapMutations("global", ['setIsHideHeader']),
    closeSidebar: function () {
      this.toggleSidebar(false);
    },
    toggleSidebar: function (isSidebarOpen) {
      this.isSidebarOpen = isSidebarOpen;
      if (isSidebarOpen) {
        this.setIsHideHeader(true);
      } else {
        this.setIsHideHeader(false);
      }
    },
    resolvedPadding(isHidden) {
      if(this.validParam.length > 0 && !isHidden){
        return '28px'
      }
      if(this.validParam.length > 0 && isHidden){
        return '100px'
      }
      return '50px';
    },
    getResponsiveHeightOffset() {
      const screenHeight = window.innerHeight;
      const screenWidth = window.innerWidth;
      
      if (screenWidth <= 768) {
        return screenHeight <= 667 ? '200px' : '220px';
      }

      if (screenWidth <= 1024) {
        return screenHeight <= 768 ? '240px' : '260px';
      }
      if (screenHeight <= 768) {
        return '220px';
      } else if (screenHeight <= 1080 && !this.$route?.params?.name) {
        return '250px';
      } else if (this.$route?.params?.name) {
        return '350px';
      } else {
        return '280px';
      }
    },

    updateResolvedHeight() {
      const container = document.getElementById('header');
      if (!container) return;

      const style = window.getComputedStyle(container);
      const isHidden = style.display === 'none';
      
      const dynamicOffset = this.getResponsiveHeightOffset();
      
      this.currentResolvedHeight = this.validParam.length > 0 && !isHidden
        ? `calc(100vh - ${dynamicOffset})`
        : this.contentHeight;

      this.currentResolvedPadding = this.resolvedPadding(isHidden);
    }

    
  },
  computed: {
    resolvedHeight() {
      return this.currentResolvedHeight;
    },
    validParam() {
      return this.$route.params.name || "";
    }
  },
  mounted() {
    const container = document.getElementById('header');
    
    if (container) {
      this._observer = new MutationObserver(() => {
        this.updateResolvedHeight();
      });

      this._observer.observe(container, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    this._resizeHandler = () => {
      this.updateResolvedHeight();
    };
    
    window.addEventListener('resize', this._resizeHandler);
    window.addEventListener('orientationchange', this._resizeHandler);
    
    this.updateResolvedHeight();
  },
  beforeUnmount() {
    if (this._observer) {
      this._observer.disconnect();
    }
    
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
      window.removeEventListener('orientationchange', this._resizeHandler);
    }
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Lexend Deca";
  src: local("Lexend Deca"),
    url(@/assets/fonts/LexendDeca-Regular.ttf) format("truetype");
}

#filter-app {
  background-color: #fafafa;
  margin: 0;
  overflow-x: hidden;
  flex: 22;
  font-family: "Lexend Deca", Helvetica, Arial;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

@media only screen and (max-width: 1230px) {
  #filter-app {
    min-width: 230px;
  }
}

@media only screen and (max-width: 1100px) {
  #filter-app {
    flex: 0;
    min-width: 0;
  }
}

#filter-app::-webkit-scrollbar {
  width: 4px;
  background-color: #f5f5f5;
}

#filter-app::-webkit-scrollbar-thumb {
  background-color: lightgray;
}

.filter-app-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

#filter-drawer-container {
  background: #efefef;
  box-shadow: 0px -2px 22px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 77px;
  padding: 16px;
  z-index: 1000;
}

#filter-drawer-button {
  border-radius: 4px;
  background: #ff7a00;
  color: #fff;
  text-transform: none;
  font-family: "Lexend Deca";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 248px;
  height: 49px;
  flex-shrink: 0;
  opacity: 1;
  z-index: 1000;
}
@media only screen and (max-width: 1100px) {
  #filter-drawer-container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    font-weight: normal;
  }
}

.isSidebarOpen-bottom-transition-enter-active,
.dialog-bottom-transition-leave-active {
  transition: transform 0.2s ease-in-out;
}

.title {
  font-family: "Lexend Deca";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;

  color: #ffffff;
}
</style>
